import React from "react";
import { Button } from "../button/button";
import DialogPropTypes from "./dialog.type";
import { DialogFooterStyles, DialogStyle } from "./dialog.style";

const Dialog = ({
  DialogHeader,
  DialogFooter,
  confirmBtnTitle,
  confirmBtnColor,
  isConfirming,
  disableConfirmBtn,
  onConfirm,
  closeBtnTitle,
  onClose,
  className,
  children,
  noScroll = false,
  noFooter = false,
}) => {
  const DialogFooterReusable = React.useMemo(
    () => (
      <DialogFooterStyles>
        <div className="footer">
          {confirmBtnTitle && (
            <Button
              onClick={onConfirm}
              disabled={disableConfirmBtn || isConfirming}
              isLoading={isConfirming}
              // color="inherit"
              style={{ backgroundColor: confirmBtnColor }}
              sx={{ width: "120px" }}
              className="confirm-btn"
            >
              {confirmBtnTitle}
            </Button>
          )}
          {closeBtnTitle && (
            <Button
              onClick={onClose}
              disabled={isConfirming}
              variant="outlined"
              sx={{ width: "120px" }}
            >
              {closeBtnTitle}
            </Button>
          )}
        </div>
      </DialogFooterStyles>
    ),
    [
      closeBtnTitle,
      confirmBtnTitle,
      confirmBtnColor,
      disableConfirmBtn,
      isConfirming,
      onClose,
      onConfirm,
    ]
  );

  return (
    <DialogStyle maxWidth={false} classes={{ paper: className }} open={true}>
      {DialogHeader}
      <div
        className="dialog-body"
        style={{ height: "100%", overflowY: noScroll ? "hidden" : "auto" }}
      >
        {children}
      </div>
      {!noFooter && <>{DialogFooter ? DialogFooter : DialogFooterReusable}</>}
    </DialogStyle>
  );
};

Dialog.propTypes = DialogPropTypes;

export default Dialog;
